import { render } from "./paginationSlider.vue?vue&type=template&id=39fc48b1&scoped=true"
import script from "./paginationSlider.vue?vue&type=script&lang=js"
export * from "./paginationSlider.vue?vue&type=script&lang=js"

import "./paginationSlider.vue?vue&type=style&index=0&id=39fc48b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fc48b1"]])

export default __exports__